module.exports = __webpack_public_path__ + "img/send.9b95e1bc.svg";